export default "__VITE_ASSET__CWNQ8ZP4__"